import type { ProductWithHyperguestHotel } from '@travel-planner/shared/schemas';

// Float queued (pending-Save) rows to the top of the middle table so the
// consultant sees what's about to be applied before hitting Save. Stable:
// relative order within the pending group and within the rest is preserved.
export const sortPendingFirst = (
  rows: ProductWithHyperguestHotel[],
  pendingIds: Set<string>
): ProductWithHyperguestHotel[] => {
  const pending: ProductWithHyperguestHotel[] = [];
  const rest: ProductWithHyperguestHotel[] = [];
  for (const row of rows) {
    if (pendingIds.has(row.productHotel.id)) pending.push(row);
    else rest.push(row);
  }
  return [...pending, ...rest];
};

// Prepend freshly-queued manual matches (which have no server row yet) to the
// server-fetched matched rows, dropping any whose product already appears in
// the server set so a row is never shown twice.
export const mergePendingManualRows = (
  serverRows: ProductWithHyperguestHotel[],
  pendingManualRows: ProductWithHyperguestHotel[]
): ProductWithHyperguestHotel[] => {
  if (pendingManualRows.length === 0) return serverRows;
  const serverIds = new Set(serverRows.map((r) => r.productHotel.id));
  const fresh = pendingManualRows.filter(
    (r) => !serverIds.has(r.productHotel.id)
  );
  return [...fresh, ...serverRows];
};
